import React from "react";

import Hero from "../components/site/Hero";
import PromiseBar from "../components/site/PromiseBar";
import HowItWorks from "../components/site/HowItWorks";
import WhatWeBuy from "../components/site/WhatWeBuy";
import About from "../components/site/About";
import WhySell from "../components/site/WhySell";
import WhereWeBuy from "../components/site/WhereWeBuy";
import FAQ from "../components/site/FAQ";
import LeadForm from "../components/site/LeadForm";

const HomePage = () => (
  <main data-testid="home-page">
    <Hero />
    <PromiseBar />
    <HowItWorks />
    <WhatWeBuy />
    <About />
    <WhySell />
    <WhereWeBuy />
    <FAQ />
    <LeadForm />
  </main>
);

export default HomePage;
